export default __webpack_public_path__ + "f2fab248966152826d98cafde10de51f.svg";